import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { AuthState } from '../../common/auth';
import { useAuth } from '../../common/hooks/useAuth';
import { useNavigation } from '../../common/navigation';
import { TwoFactorVerify } from '../components/TwoFactorVerify/TwoFactorVerify';

export const TwoFactorVerifyView: React.FC = () => {
  const auth = useAuth();
  const nav = useNavigation();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string })?.from ?? '/';

  if (auth.state === AuthState.LoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (auth.state === AuthState.LoggedOut) {
    return <Navigate to="/login" replace />;
  }

  const handleVerify = async (code: string) => {
    await auth.verifyTwoFactor(code);
    const forcedReturnTo = sessionStorage.getItem('forced_logout_return_to');
    if (forcedReturnTo) {
      sessionStorage.removeItem('forced_logout_return_to');
    }
    setTimeout(() => navigate(forcedReturnTo ?? from, { replace: true }), 0);
  };

  const handleLogout = async () => {
    await auth.logout();
    void nav.login();
  };

  return (
    <TwoFactorVerify
      onVerify={handleVerify}
      onResend={auth.initTwoFactor}
      onLogout={handleLogout}
    />
  );
};
